import logo from "../assets/2.png";

import Footer from "./footer";
import { useNavigate } from "react-router-dom";

// GitHub Releases (LATEST version)
const WINDOWS_DOWNLOAD =
  "https://github.com/gibolab/gibo/releases/latest/download/Gibo-Setup.exe";



// Helper to trigger download
const downloadFile = (url) => {
  const a = document.createElement("a");
  a.href = url;
  a.rel = "noopener noreferrer";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};

const Installer = () => {
  const navigate = useNavigate();

  return (
    <div className="home-layout">
      {/* Logo */}
      <img
        src={logo}
        className="home-logo"
        onClick={() => navigate("/")}
        style={{ cursor: "pointer" }}
        alt="Gibo logo"
      />

          <button onClick={() => downloadFile(WINDOWS_DOWNLOAD)} className="download-btn">
            Download for Windows
          </button>
          <p className="download-btn">Mac coming soon!!</p>
      <div className="installer-box">
        <p><span style={{fontWeight: 800}}>Software Version: </span>1.1.1</p>
        <p><span style={{fontWeight: 800}}>License Type: </span>Desktop Only</p>
        <p><span style={{fontWeight: 800}}>Account Type: </span>Personal User Account</p>

        <p>This license grants you free access to use Gibo for
           personal organization and productivity purposes. The license is linked to your user account and is valid as long as your account remains active.
</p>

<p>The free license includes access to core features available in the current version of the software. Future updates, features, or plans may be introduced and could be subject to different licensing terms.
</p>

        <div className="installers">
          {/* Windows */}

          
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Installer;
